import grey from "@mui/material/colors/grey";

const styles = {
  arrowContainer: {
    fontSize: 18,
    border: `1px solid ${grey[300]}`,
    borderTop: 0,
    borderBottom: 0,
    p: 0.5,
  },
  hideBorderLeft: {
    borderLeft: 0,
  },
  hideBorderRight: {
    borderRight: 0,
  },
  arrowIcon: {
    color: grey[400],
    background: "white",
    borderRadius: 0,
    fontWeight: 400,
  },
};

export default styles;
